document.addEventListener("DOMContentLoaded", () => {
  handleVideoPause();
});

function handleVideoPause() {
  document.querySelectorAll('video-media[show-play-button]').forEach((videoMedia) => {
    videoMedia.addEventListener('click', (e) => {
      const target = e.target.closest('video-media[show-play-button]');
      if (!target) return;

      // Snapshot loaded state before component's handler fires
      const wasLoaded = target.hasAttribute('loaded');
      if (!wasLoaded) return;

      const video = target.querySelector('video');
      if (!video) return;

      video.paused ? video.play() : video.pause();
    }, true); // capturing phase
  });
}